define([
    'text!index2024-buyChannel/component/item-design.html',
    'index2024-buyChannel/mixin/form',
    'index2024-buyChannel/common/api',

    'css!index2024-buyChannel/main.css',
], function(
    tpl,
    FormMixin,
    Api
){
    return {
        template: tpl,
        mixins: [FormMixin],
        methods: {
            resetForm: function(){
                this.form = {
                    type: 2,
                    companyName: '',
                    contact: '',
                    phone: '',
                    email: '',
                    attch: '',
                    remark: '',
                    memberId: ''
                };
            }
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./index2024-shops/component/item-design.js
// module id = 380
// module chunks = 4